import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/ConsultarView',
    name: 'ConsultarView',
    component: () =>
      import(
        '../views/consultar/ConsultarView.vue'),
    meta: {
      title: 'Consultar',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('ConsultarView'),
      bread: {
        path: [
          'Registros',
        ],
      },
    },
  },
];
